import React from "../_snowpack/pkg/react.js";
import {colors} from "./theme.js";
import styled from "../_snowpack/pkg/@emotion/styled.js";
import {media} from "./theme.js";
import {getUrl} from "../common/universal.js";
import {Home} from "./icons.js";
import {Routes} from "../typings/routes.js";
export default function BreadCrumb(props) {
  const {page, category} = props;
  return /* @__PURE__ */ React.createElement(BreadCrumbContainer, null, /* @__PURE__ */ React.createElement(HomeIconLink, {
    href: getUrl(Routes.home)
  }, /* @__PURE__ */ React.createElement(Home, null)), /* @__PURE__ */ React.createElement(BreadCrumbSpan, null, "/"), /* @__PURE__ */ React.createElement(CategoryLink, {
    href: getUrl(Routes.productCategory, {slug: category.slug})
  }, category.name), page && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(BreadCrumbSpan, null, "/"), /* @__PURE__ */ React.createElement(BreadCrumbSpan, null, page.name)));
}
const CategoryLink = styled.a`
  color: ${colors.b2};
  text-decoration: none;

  &:hover {
    color: ${colors.b};
  }
`;
const BreadCrumbContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  gap: 5px;
  text-transform: capitalize;

  ${media.mobile} {
    display: none;
  }
`;
const HomeIconLink = styled.a`
  text-decoration: none;
  display: flex;
  align-items: center;
`;
const BreadCrumbSpan = styled.span`
  color: ${colors.b2};
`;
